<template>
    <main id="mainCtrl">
        <dialog-clinic-moderation ref="clinicModerate" @updated="onUpdatedEvent" @openNext="moderateNext"/>
        <v-table
            id="mainTbl"
            request-uri="clinics/getList"
            pagesize="50"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="source" width="60" tooltip="Источник данных">Ист</v-th>
                    <v-th name="city" sort="city" width="55" >Город</v-th>
                    <v-th name="created_at" sort="clinics.created_at" width="100">Создана</v-th>
                    <v-th name="nameOrAddress" sort="clinics.name">Клиника</v-th>
                    <v-th name="rating" sort="rating" width="40" ><i class="fas fa-star-half-alt"></i></v-th>
                    <v-th name="registryPhone" sort="registryPhone" width="125">Тел клиники</v-th>
                    <v-th name="clinicPhone" sort="phone" width="125">Тел Doctu.ru</v-th>
                    <v-th name="reportOn" sort="reportOn" width="30" tooltip="Автоматическая отправка отчетов">АО</v-th>
                    <v-th name="doctors_count" sort="doctors_count"  width="50">Врачи</v-th>
                    <v-th name="hasSubscription" width="30"><i class="fas fa-up"></i></v-th>
                    <v-th name="url" sort="clinics.url" minwidth="100">URL</v-th>
                    <v-th name="description">Коммент</v-th>
                    <v-th name="moderation_created_at" sort="moderation_created_at" width="100">Изменена</v-th>
                </v-tr>
                <v-tr>
                    <v-th name="source"></v-th>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    text: "\u00a0",
                                    value: ""
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="created_at" v-slot="{filter}">
                            <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="nameOrAddress" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="rating" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                {
                                    text: '\u00a0',
                                    value: ''
                                },
                                {
                                    value: '-',
                                    text: '- нет'
                                },
                                {
                                    value: '1',
                                    text: '1 ★☆☆☆☆'
                                },
                                {
                                    value: '2',
                                    text: '2 ★★☆☆☆'
                                },
                                {
                                    value: '3',
                                    text: '3 ★★★☆☆'
                                },
                                {
                                    value: '4',
                                    text: '4 ★★★★☆'
                                },
                                {
                                    value: '5',
                                    text: '5 ★★★★★'
                                }
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="registryPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="clinicPhone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th class="fa-hack" name="reportOn" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: " Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="doctors_count" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: ">0",
                                    text: "Есть врачи"
                                },
                                {
                                    value: "=0",
                                    text: "0 врачей"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="hasSubscription" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "true",
                                    text: "Есть кнопка записи"
                                },
                                {
                                    value: "false",
                                    text: "Нет кнопки записи"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="url" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="moderation_created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="source">
<!--                     orangered   color: #0000003b-->
                        <div v-tooltip="'Сеть'"
                            :class="[item.hasNetworkModeration ? 'activeSource' : 'notActiveSource']"><i class="fa fa-lg fa-code-fork"></i></div>
                        <div  v-tooltip="'Клиника'"
                            :class="[item.hasClinicModeration ? 'activeSource' : 'notActiveSource']"><i class="fa fa-lg fa-building"></i></div>

                    </v-td>
                    <v-td name="city" highlight="*" align="center">{{
                            cityOptions.find(city => {
                                return city.value === item.city
                            }).textAbbr
                        }}
                    </v-td>
                    <v-td name="created_at" highlight="*" >{{ item.created_at | formatDate }}</v-td>
                    <v-td name="nameOrAddress">
                        <div><b>{{ item.name }}</b></div>
                        <div>{{ item.address }}</div>
                    </v-td>
                    <v-td name="rating" highlight="*" align="center">
                        <span v-if="item.rating == null" v-tooltip="'Внутренний: '+ item.ratingInternal">&mdash;</span>

                        <template v-else>
                            <span v-tooltip="{content:innerTooltip(item)}">
                                {{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}
                            </span>
                        </template>
                    </v-td>
                    <v-td name="registryPhone" align="center">{{ item.registryPhone }}</v-td>
                    <v-td name="clinicPhone" align="center">{{ item.phone }}</v-td>
                    <v-td name="reportOn" highlight="*" align="center" width="30">
                        <template v-if="item.reportOn">
                            <i class="fa fa-check text-success" v-tooltip="`${item.reportToName}<br/>${item.reportTo}<br/>${item.reportCc}`"></i>
                        </template>
                    </v-td>
                    <v-td name="doctors_count" highlight="*" align="center" width="50">{{ item.doctors_count }}</v-td>
                    <v-td name="hasSubscription" align="center" width="30">
                        <i v-if="item.hasSubscription" class="fas fa-up text-success" tooltip="Есть активная подписка"></i>
                        <i v-else class="far fa-minus text-danger" tooltip="Нет активной подписки"></i>
                    </v-td>
                    <v-td name="url" minwidth="100">
                        <a class="text-ellipsis"
                            @click.prevent.stop="openHref(frontendUrl + '/' + item.city + '/clinic/' + item.url)"
                            :href="frontendUrl + '/' + item.city + '/clinic/' +item.url"
                            v-tooltip="`${frontendUrl}/${item.city}/clinic/${item.url}`"
                            target='_blank'>
                            /{{ item.url }}
                        </a>
                    </v-td>
                    <v-td name="description">{{ item.description }}</v-td>
                    <v-td name="moderation_created_at" highlight="*" align="center">
                      <template v-for="moderation in item.moderations">
                            {{moderation.created_at  | formatDate }} <br/>
                      </template>
                    </v-td>
                </v-tr>
            </template>
        </v-table>

    </main>
</template>

<script>
import DialogClinicModeration from '@dialogs/admin/clinicModeration/Dialog'
export default {
    components: { DialogClinicModeration },
    props: {
        cityOptions: {
            type: Array,
            required: true
        },
        metroOptions: {
            type: Array,
            required: true
        },
        typeOptions: {
            type: Array,
            required: true
        },
        areaOptions: {
            type: Array,
            required: true
        },
        localityOptions: {
            type: Array,
            required: true
        },
        districtOptions: {
            type: Array,
            required: true
        },
        frontendUrl: {
            type: String,
            required: true
        }
    },

    data: function () {return {}},
    created: function () {
            this.$store.dispatch('dictionary/fetchAllOptions');
    },
    methods: {
        onUpdatedEvent (){
            this.$refs.table.update();
        },
        handleRowClick: function (event, row, item) {

            row.startLoadingAnimation();

            this.moderateClinic(item.id, event, row);
        },
        moderateClinic: function (clinicId, e, row)  {
                this.$refs.clinicModerate
                    .showModal(clinicId)
                    .then(() => row.stopLoadingAnimation())
                    .catch(() => row.stopLoadingAnimation());

        },
        moderateNext: function (clinicId) {
            setTimeout(async () => {
                let previousClinicId = clinicId;
                let row, index;

                for (const i in this.$refs.table.rows) {
                    index = parseInt(i);
                    row = this.$refs.table.rows[index];

                    if (row.id === previousClinicId && this.$refs.table.rows[index + 1] && this.$refs.table.rows[index + 1].id) {
                        await this.axios.get('/admin/moderation/clinics/' + this.$refs.table.rows[index + 1].id + '/isOpened')
                            .then(data => {
                                if (data.data.success) {
                                    const nextRow = document.querySelectorAll('#mainTbl table tbody tr.table-row')[index + 1];
                                    if (nextRow) {
                                        nextRow.click();
                                    }
                                    this.$refs.table.update();
                                } else {
                                    previousClinicId = this.$refs.table.rows[index + 1].id;
                                }
                            });
                    }
                }
            }, 1000);
        },
        innerTooltip(item) {
            return `<div class="tooltip-content">
                    <table>
                        <tr><td width="85">Рейтинг:</td><td width="50">` + (Math.round(item.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                        <tr><td>Отзывы:</td><td>` + item.ratingCommentCount + `</td></tr>
                        <tr><td>Внутренний:</td><td>` + item.ratingInternal + `</td></tr>
                    </table>
            </div>`;
        },

        openHref(href) {
            window.open(href)
        },
    }

}
</script>
<style>
.activeSource {
    display: inline;
    color: orangered;
}
.notActiveSource {
    display: inline;
    color: #0000003b;
}
</style>
